export const oneDay = 1
const oneDayHours = 24
const oneHourMinutes = 60
export const oneDayMinutes = oneDayHours * oneHourMinutes
const oneYears = oneDay * 365
export const fiveYears = oneYears * 5
const oneHour = oneDay / 24
export const tenMinutes = oneHour / 6
